var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
var UnauthorisedComponent = /** @class */ (function () {
    function UnauthorisedComponent() {
        this.viewModel = {
            title: 'Uh-oh!',
            subTitle: 'You\'re not authorised to access this page',
            imageAltText: 'User unauthorised'
        };
    }
    UnauthorisedComponent = __decorate([
        Component({
            selector: 'shared-unauthorised',
            template: require('./unauthorised.component.html'),
            styles: [require('./unauthorised.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], UnauthorisedComponent);
    return UnauthorisedComponent;
}());
export { UnauthorisedComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5hdXRob3Jpc2VkLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVuYXV0aG9yaXNlZC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQVExQztJQUVJO1FBQ0ksSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLEtBQUssRUFBRSxRQUFRO1lBQ2YsUUFBUSxFQUFFLDRDQUE0QztZQUN0RCxZQUFZLEVBQUUsbUJBQW1CO1NBQ3BDLENBQUM7SUFDTixDQUFDO0lBUlEscUJBQXFCO1FBTGpDLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxxQkFBcUI7WUFDL0IsUUFBUSxFQUFFLE9BQU8sQ0FBQywrQkFBK0IsQ0FBQztZQUNsRCxNQUFNLEVBQUUsQ0FBQyxPQUFPLENBQUMsK0JBQStCLENBQUMsQ0FBQztTQUNyRCxDQUFDOztPQUNXLHFCQUFxQixDQVNqQztJQUFELDRCQUFDO0NBQUEsQUFURCxJQVNDO1NBVFkscUJBQXFCIn0=